import { ENV_CONFIG } from './config';

export const APP_ENV = {
  prod: 'prod',
  prodWhite: 'prodWhite',
  qa: 'qa',
  qaWhite: 'qaWhite',
  stg: 'stg',
  stgWhite: 'stgWhite',
  tst: 'tst',
  tstWhite: 'tstWhite',
} as const;

export type AppEnv = keyof typeof APP_ENV;

export const BUILD_MODE = {
  development: 'development',
  production: 'production',
};

export const IS_PRODUCTION_BUILD = import.meta.env.VITE_MODE !== BUILD_MODE.development;
export const IS_LOCAL_BUILD = import.meta.env.MODE === BUILD_MODE.development;
export const IS_MOCKING_ENABLED = !!import.meta.env.VITE_ENABLE_MOCKING;

export const APP_CONFIG_ENV_MAP = {
  [APP_ENV.prod]: ENV_CONFIG.PROD,
  [APP_ENV.prodWhite]: ENV_CONFIG.PROD_WHITE,
  [APP_ENV.qa]: ENV_CONFIG.QA,
  [APP_ENV.qaWhite]: ENV_CONFIG.QA_WHITE,
  [APP_ENV.stg]: ENV_CONFIG.STG,
  [APP_ENV.stgWhite]: ENV_CONFIG.STG_WHITE,
  [APP_ENV.tst]: ENV_CONFIG.TST,
  [APP_ENV.tstWhite]: ENV_CONFIG.TST_WHITE,
} as const;

export const LS_ENV_KEY = 'env';

export const CURRENT_ENV = (() => {
  if (IS_PRODUCTION_BUILD) {
    return '';
  }

  const lsEnv = (window.localStorage.getItem(LS_ENV_KEY) ?? '') as keyof typeof APP_ENV;

  if (lsEnv || IS_LOCAL_BUILD) return lsEnv;

  return (import.meta.env.VITE_APP_ENV as AppEnv) || APP_ENV.stg;
})();

// TODO move all 3d party flags to abstraction slice [hash234123]
export const IS_MIXPANEL_DEV_MODE_ENABLED = sessionStorage.getItem('enableMixpanel') === '1';
export const IS_LOGROCKET_DEV_MODE_ENABLED = sessionStorage.getItem('enableLogRocket') === '1';
